import { useRouter as r } from "next/router";
import * as i from "ramda";
import { useCallback as a, useEffect as u } from "react";
const m = () => {
  const e = r(), n = a(async () => {
    var o;
    const t = (o = document.querySelector("#__NEXT_DATA__")) == null ? void 0 : o.textContent;
    if (i.isNotNil(t)) {
      const s = `/_next/static/${JSON.parse(t).buildId}/_buildManifest.js`;
      return (await fetch(`${window.location.origin}${s}`)).ok;
    }
    return !0;
  }, []);
  u(() => {
    const t = async () => {
      await n() || window.location.reload();
    };
    return e.events.on("routeChangeStart", t), () => {
      e.events.off("routeChangeStart", t);
    };
  }, [e]);
};
export {
  m as default
};
//# sourceMappingURL=useBuildChecker.js.map
